import React from 'react';
import { colors, spacing, shadows } from '../../../design/tokens';

export const HowItWorks: React.FC = () => {
  const steps = [
    {
      num: '01',
      title: 'Scan & Detect',
      desc: 'Connect your repository and run a deep security scan. Exibrain identifies vulnerabilities and logic bugs instantly.'
    },
    {
      num: '02',
      title: 'Generate Fix',
      desc: 'Our engine analyzes the issue and generates a precise fix tailored to your codebase and style.'
    },
    {
      num: '03',
      title: 'Auto-Validate',
      desc: 'The fix is automatically built and tested in a sandbox. We only present solutions that are verified to work.'
    },
    {
      num: '04',
      title: 'Deploy Safely',
      desc: 'Review the fix as a Pull Request and merge it with confidence, knowing it has been fully validated.'
    }
  ];

  return (
    <section id="how-it-works" style={{ padding: `${spacing.xxl} ${spacing.xl}`, backgroundColor: colors.neutral[1000], color: 'white' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: spacing.xxl }}>
          <h2 style={{ fontSize: '40px', fontWeight: 800, color: 'white', marginBottom: spacing.md, letterSpacing: '-0.02em' }}>How Exibrain Works</h2>
          <p style={{ fontSize: '18px', color: colors.neutral[400], maxWidth: '700px', margin: '0 auto' }}>
            A fully automated loop designed to eliminate manual debugging overhead.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: spacing.xl }}>
          {steps.map((s, i) => (
            <div key={i} style={{ position: 'relative' }}>
              <div style={{ 
                fontSize: '48px', 
                fontWeight: 900, 
                color: 'rgba(255,255,255,0.08)', 
                marginBottom: spacing.sm,
              }}>{s.num}</div>
              <div style={{ position: 'relative', zIndex: 1 }}>
                <h3 style={{ fontSize: '22px', fontWeight: 700, marginBottom: spacing.sm, color: 'white' }}>{s.title}</h3>
                <p style={{ color: colors.neutral[400], lineHeight: 1.6, fontSize: '15px' }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div style={{ 
          marginTop: spacing.xxl, 
          padding: spacing.xl, 
          backgroundColor: 'rgba(255,255,255,0.05)', 
          borderRadius: '12px', 
          textAlign: 'center',
          border: '1px solid rgba(255,255,255,0.1)'
        }}>
          <p style={{ fontSize: '18px', fontStyle: 'italic', color: colors.neutral[200], marginBottom: spacing.md, maxWidth: '800px', margin: '0 auto 16px' }}>
            "Exibrain reduced our security remediation cycle from 5 days to 45 minutes."
          </p>
          <div style={{ fontWeight: 600, fontSize: '14px', color: colors.neutral[400] }}>— VP Engineering, Fortune 500 FinTech</div>
        </div>
      </div>
    </section>
  );
};
